import { strings } from "../../strings/strings";
import { SpinnerIcon } from "../../assets/Icons/icons";

const Button = ({
  variant = "primary",
  size = "md",
  isLoading = false,
  disabled = false,
  className = "",
  children,
  ...props
}) => {
  const baseStyles =
    "font-medium rounded-lg transition-all focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed";

  const variants = {
    primary: "bg-primary text-white hover:opacity-90 shadow-sm",
    secondary: "bg-secondary text-white hover:opacity-90 shadow-sm",
    outline: "bg-white text-secondary border border-secondary hover:bg-gray-50",
    danger: "bg-red-600 text-white hover:bg-red-700 shadow-sm",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-5 py-2.5 text-sm",
    lg: "px-6 py-3 text-base",
  };

  const variantClasses = variants[variant] || variants.primary;
  const sizeClasses = sizes[size] || sizes.md;

  return (
    <button
      className={`${baseStyles} ${variantClasses} ${sizeClasses} ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center justify-center gap-2">
          <SpinnerIcon className="animate-spin h-4 w-4" />
          {strings.loading}
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
